/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneEvent } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  MyButton,
  MySearch,
  Pagination,
  DashboardIntro,
} from "../../home/component/Component";
import { _TYPES_ } from "../utils/types";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import PromoteContent from "../utils/PromoteContent";
import { FaRegCheckSquare, FaRegSquare, FaRegTrashAlt } from "react-icons/fa";
import { RiRefreshLine } from "react-icons/ri";

const addRoute = "/data/event/add";
const editRoute = "/data/event/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const [eventsList, setEventsList] = useState([]);
  const { events, eventsCount, fetchDoSeeData, deleteOneContent } =
    useDoSeeDataContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);
  const [localSearch, setLocalSearch] = useState([]);

  const [loading, setLoading] = useState(false);
  const [selectedContentIds, setSelectedContentIds] = useState([]);
  const [showBulkDelete, setShowBulkDelete] = useState(false);

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_.EVENT,
  };

  useEffect(() => {
    if (!events) fetchDoSeeData(data_request_body, page, pageSize);
    setEventsList(events);
  }, [events]);

  const reloadData = () => fetchDoSeeData(data_request_body, page, pageSize);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    events?.map((evt) => {
      if (evt.title.toString().toLowerCase().includes(key))
        return searchArray.push(evt);
      return true;
    });
    setEventsList(searchArray);
    if (key === "") setEventsList(events);
  };

  const LocalData = localSearch?.length > 0 ? localSearch : eventsList;

  // --- Robust Select-All (page/filtered aware) ---
  const allIds = useMemo(
    () => (LocalData || []).map((e) => e?.event_id).filter(Boolean),
    [LocalData]
  );

  const allSelected =
    allIds.length > 0 && allIds.every((id) => selectedContentIds.includes(id));

  const toggleAll = () => {
    setSelectedContentIds((prev) =>
      allSelected
        ? prev.filter((id) => !allIds.includes(id)) // unselect visible
        : Array.from(new Set([...prev, ...allIds])) // select visible
    );
  };

  useEffect(() => {
    // prune selections that are no longer visible
    setSelectedContentIds((prev) => prev.filter((id) => allIds.includes(id)));
  }, [allIds]);
  // -----------------------------------------------

  const deleteMany = async () => {
    setLoading(true);
    for (let i = 0; i < selectedContentIds.length; i++) {
      await deleteOneContent({
        data_id: selectedContentIds[i],
        content: _TYPES_.EVENT,
      });
    }
    setLoading(false);
    setShowBulkDelete(false);
    reloadData();
  };

  const btnBase =
    "inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";
  const card =
    "overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm";

  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:py-6">
        <div className="mb-4">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: doseeDataRoutes }} />
        </div>

        <div className="mb-6">
          <DashboardIntro props={{ intro: `Events`, name: entry_label }} />
        </div>

        <div className="flex flex-col gap-4">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <MySearch
              type={_TYPES_.EVENT}
              value={localSearch}
              showGlobalSearch={true}
              setValue={setLocalSearch}
              onChange={(e) => SearchList(e)}
            />

            {country_id ? (
              <Link to={addRoute} className="shrink-0">
                <MyButton
                  title="Add Event"
                  className={`${btnBase} ${btnPrimary}`}
                  onClick={() => { }}
                />
              </Link>
            ) : null}
          </div>

          <div className="flex items-center gap-3">
            <MyButton
              className={`${btnBase} ${btnNeutral}`}
              onClick={toggleAll}
              disabled={allIds.length === 0}
            >
              {allSelected ? (
                <FaRegCheckSquare className="text-green-600 text-lg" />
              ) : (
                <FaRegSquare className="text-slate-700 text-lg" />
              )}
              <span className="text-slate-700">
                {allSelected ? "Unselect All" : "Select All"}
              </span>
            </MyButton>

            <MyButton
              onClick={() =>
                selectedContentIds?.length > 0 && setShowBulkDelete(true)
              }
              className={`${btnBase} ${selectedContentIds?.length > 0 ? btnDanger : btnNeutral
                }`}
              disabled={selectedContentIds?.length === 0 || loading}
            >
              {loading ? (
                <RiRefreshLine className="text-lg animate-spin" />
              ) : (
                <FaRegTrashAlt className="text-base" />
              )}
              <span>
                Delete{" "}
                {selectedContentIds?.length > 0 ? selectedContentIds.length : ""}{" "}
                {selectedContentIds?.length === 1 ? "Item" : "Items"}
              </span>
            </MyButton>
          </div>

          <div className={card}>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-600">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold">Select</th>
                    <th className="px-4 py-3 text-left font-semibold">Title</th>
                    <th className="px-4 py-3 text-left font-semibold">Slug</th>
                    <th className="px-4 py-3 text-center font-semibold">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  {events || LocalData ? (
                    LocalData?.map((evt, key) => (
                      <tr
                        key={key}
                        className="hover:bg-slate-50 transition-colors"
                      >
                        <td className="px-4 py-3">
                          <MyButton
                            className={`${btnBase} ${btnNeutral}`}
                            onClick={() =>
                              setSelectedContentIds((prev) =>
                                prev.includes(evt?.event_id)
                                  ? prev.filter((id) => id !== evt?.event_id)
                                  : [...prev, evt?.event_id]
                              )
                            }
                          >
                            {selectedContentIds.includes(evt?.event_id) ? (
                              <FaRegCheckSquare className="text-green-600 text-lg" />
                            ) : (
                              <FaRegSquare className="text-slate-700 text-lg" />
                            )}
                          </MyButton>
                        </td>
                        <td className="px-4 py-3">{evt?.title}</td>
                        <td className="px-4 py-3">{evt?.slug}</td>
                        <td className="px-2 py-3">
                          <ActionButton props={evt} reloadData={reloadData} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="animate-pulse">
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={eventsCount}
            callbackFunction={(p, size) => {
              fetchDoSeeData(data_request_body, p, size);
            }}
          />
        </div>

        <div className="relative z-[9999]">
          <Modal
            props={{
              name: `Delete ${selectedContentIds?.length} ${selectedContentIds?.length === 1 ? "Item" : "Items"
                }`,
              showModal: showBulkDelete,
              setShowModal: () => setShowBulkDelete(false),
              delete: deleteMany,
            }}
          />
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ props, reloadData }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const { events, deleteOneContent, updateOneContent } = useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);
  const [confirmSuspend, setConfirmSuspend] = useState(false);

  const [promote, setPromote] = useState(false);
  const [promoteLoader, setPromoteLoader] = useState(false);

  const event_id = props.event_id;
  const event_title = props.title;
  const event = props;

  const deleteOneEventById = async (event_id) => {
    const { status } = await deleteOneContent({
      data_id: event_id,
      content: _TYPES_.EVENT,
    });
    setShowModal(false);
    if (status === 200) {
      reloadData();
    }
  };

  const buildData = (object, position) => {
    return {
      country_id: object?.country_id,
      description: object?.description,
      first_level_id: object?.first_level_id,
      fourth_level_id: object?.fourth_level_id,
      second_level_id: object?.second_level_id,
      third_level_id: object?.third_level_id,
      promoted: `${position}`,
      slug: object?.slug,
      status: object?.status,
      thumbnail: object?.thumbnail,
      image_cdn_id: object?.image_cdn_id,
      title: object?.title,
      url_images: object?.url_images,
    };
  };

  const promotion = async (position) => {
    const previousPromoted = events?.find(
      (event) => event?.promoted === String(position)
    );
    setPromoteLoader(true);
    const { status } = await updateOneContent({
      data_id: event?.event_id,
      data: buildData(props, position),
      content: _TYPES_.EVENT,
    });
    if (previousPromoted) {
      await updateOneContent({
        data_id: previousPromoted?.event_id,
        data: buildData(previousPromoted, "no"),
        content: _TYPES_.EVENT,
      });
    }
    setPromoteLoader(false);
    setPromote(false);
    if (status === 200) {
      reloadData();
    }
  };

  const suspension = async (event) => {
    const data = {
      country_id: event?.country_id,
      description: event?.description,
      first_level_id: event?.first_level_id,
      fourth_level_id: event?.fourth_level_id,
      second_level_id: event?.second_level_id,
      slug: event?.slug,
      status: event?.status === 1 ? 0 : 1,
      third_level_id: event?.third_level_id,
      thumbnail: event?.thumbnail,
      title: event?.title,
      url_images: event?.url_images,
    };
    const { status } = await updateOneContent({
      data_id: event?.event_id,
      data: data,
      content: _TYPES_.EVENT,
    });
    setConfirmSuspend(false);
    if (status === 200) {
      reloadData();
    }
  };

  const btnBase =
    "bg-black text-white inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";
  const btnInfo =
    "bg-blue-700 text-white border-blue-700 hover:bg-blue-600 focus-visible:ring-blue-600";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";
  const btnWarn =
    "bg-amber-600 text-white border-amber-600 hover:bg-amber-500 focus-visible:ring-amber-500";

  return (
    <>
      <div className="relative z-[9999]">
        <Modal
          props={{
            name: event_title,
            showModal: showModal,
            setShowModal: () => setShowModal(false),
            delete: () => deleteOneEventById(event_id),
          }}
        />
      </div>

      <ConfirmDialog
        open={confirmSuspend}
        title={
          event?.status === 1 ? "Suspend this event?" : "Unsuspend this event?"
        }
        description={
          event?.status === 1
            ? "This will hide the event from public listings until re-enabled."
            : "This will make the event visible to the public again."
        }
        confirmText={event?.status === 1 ? "Suspend" : "Unsuspend"}
        cancelText="Cancel"
        onClose={() => setConfirmSuspend(false)}
        onConfirm={() => suspension(event)}
        variant={event?.status === 1 ? "neutral" : "warn"}
      />

      <div className="relative z-[9999]">
        <PromoteContent
          visible={promote}
          setVisible={setPromote}
          loading={promoteLoader}
          ids={events
            ?.filter(
              (event) =>
                !["yes", "no", null, undefined].includes(event?.promoted)
            )
            .map((event) => ({
              id: event?.event_id,
              title: event?.title,
              position: parseInt(event?.promoted),
            }))}
          onClick={(position) => promotion(position)}
        />
      </div>

      <div className="flex flex-row justify-end items-center px-2 py-2 gap-2">
        {isSuperAdmin ? (
          <>
            <MyButton
              title={event?.status === 1 ? "Suspend" : "Unsuspend"}
              className={`${btnBase} ${event?.status === 1 ? btnPrimary : btnWarn
                }`}
              onClick={() => setConfirmSuspend(true)}
            />
            <MyButton
              title={
                ["yes", "no", null, undefined].includes(event.promoted)
                  ? "Promote"
                  : "Unpromote"
              }
              className={`${btnBase} ${["yes", "no", null, undefined].includes(event.promoted)
                ? btnPrimary
                : btnWarn
                }`}
              onClick={() => setPromote(true)}
            />
          </>
        ) : null}

        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`${btnBase} ${btnInfo}`}
            onClick={() => pushOneEvent(event)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`${btnBase} ${btnDanger}`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

const ConfirmDialog = ({
  open,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onClose,
  onConfirm,
  variant = "neutral",
}) => {
  if (!open) return null;

  const btnBase =
    "inline-flex items-center justify-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnWarn =
    "bg-amber-600 text-white border-amber-600 hover:bg-amber-500 focus-visible:ring-amber-500";

  return (
    <div className="fixed inset-0 z-[9999]">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white shadow-xl">
          <div className="p-5">
            <h3 className="text-base font-semibold text-slate-900">{title}</h3>
            {description ? (
              <p className="mt-2 text-sm text-slate-600">{description}</p>
            ) : null}
            <div className="mt-5 flex items-center justify-end gap-2">
              <button
                type="button"
                className={`${btnBase} ${btnNeutral}`}
                onClick={onClose}
              >
                {cancelText}
              </button>
              <button
                type="button"
                className={`${btnBase} ${variant === "warn" ? btnWarn : btnNeutral
                  }`}
                onClick={onConfirm}
              >
                {confirmText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
